var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF7043",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68 53.007c.448.443.448 1.16 0 1.605l-6.37 6.306a1.126 1.126 0 0 1-.807.335 1.19 1.19 0 0 1-.442-.085 1.14 1.14 0 0 1-.703-1.047v-5.178h-.982c-2.845 0-5.391-1.843-5.391-5.341V30.669c0-2.815 1.863-5.336 5.391-5.336h29.747c2.848 0 5.392 1.838 5.392 5.336v2.63c0 .626-.511 1.132-1.14 1.132-.628 0-1.14-.506-1.14-1.131v-2.631c0-1.32-.522-2.156-1.417-2.639a3.67 3.67 0 0 0-1.07-.367 3.768 3.768 0 0 0-.625-.067H28.376c-1.339 0-2.186.518-2.673 1.404a3.611 3.611 0 0 0-.434 1.674v18.928c0 1.323.521 2.16 1.415 2.642.578.313 1.219.431 1.692.431h2.127c.628 0 1.139.51 1.139 1.137v3.58l4.426-4.385a1.143 1.143 0 0 1 1.612 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.236 62.226c0-.63.51-1.137 1.14-1.137h4.247c.474 0 1.116-.118 1.696-.43.895-.483 1.417-1.32 1.417-2.643V41.193a3.634 3.634 0 0 0-.439-1.675c-.488-.885-1.335-1.403-2.674-1.403H45.376c-.47 0-1.114.12-1.692.433-.893.483-1.415 1.319-1.415 2.64v16.828c0 1.323.521 2.16 1.414 2.642.579.313 1.22.431 1.693.431h6.373c.63 0 1.14.507 1.14 1.137 0 .625-.51 1.132-1.14 1.132h-6.373c-2.846 0-5.392-1.843-5.392-5.342V41.187c0-3.498 2.546-5.341 5.392-5.341h21.247c3.53 0 5.392 2.522 5.392 5.342v16.828c0 3.499-2.546 5.342-5.392 5.342h-3.107v5.177a1.142 1.142 0 0 1-1.948.8l-6.373-6.31a1.124 1.124 0 0 1 0-1.604 1.146 1.146 0 0 1 1.61 0l4.43 4.387v-3.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.502 46.53a1.14 1.14 0 0 1-1.144-1.133 1.14 1.14 0 0 1 1.144-1.136h17c.629 0 1.14.506 1.14 1.136 0 .626-.512 1.132-1.14 1.132h-17zM47.502 50.734a1.14 1.14 0 0 1-1.144-1.132 1.14 1.14 0 0 1 1.144-1.131h17c.628 0 1.14.505 1.14 1.131s-.512 1.132-1.14 1.132h-17zM47.502 54.943a1.14 1.14 0 0 1-1.144-1.131c0-.626.516-1.137 1.144-1.137h17c.628 0 1.14.51 1.14 1.137 0 .625-.512 1.131-1.14 1.131h-17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConAssistant);
export default __webpack_public_path__ + "static/media/con-assistant.73dddfea50ba06e01b61d0f1722ea0e6.svg";
export { ForwardRef as ReactComponent };